import {

    Box,
    Heading,
    Button,
    Flex,
    IconButton,
    Input,
    Stack,
    Text,
} from '@chakra-ui/react'
import { FiDownload } from 'react-icons/fi'
import { LuCopy } from 'react-icons/lu'
import { toaster } from './ui/toaster'
import { useRef } from 'react'
import { QRCodeCanvas } from 'qrcode.react'
import { useTranslation } from '../i18n'

export default function EventQR({ eventId, webappUrl, hideTitle = false }) {

    const { t } = useTranslation()
    const qrRef = useRef(null)

    let appBase = import.meta.env.VITE_PUBLIC_APP_URL || window.location.origin
    if (import.meta.env.DEV) {
        const { protocol, hostname } = window.location
        appBase = `${protocol}//${hostname}:5173`
    }
    // Prefer the URL stored on the event (single source of truth). Only fall back
    // to a bare-id URL — resolved by the webapp's back-compat route — when the
    // caller has no stored URL to pass.
    const qrValue = webappUrl || new URL(`/${eventId}`, appBase).toString();


    const downloadQR = () => {
        const canvas = qrRef.current?.querySelector('canvas')
        if (!canvas) return
        const link = document.createElement('a')
        link.download = `event-${eventId}-qr.png`
        link.href = canvas.toDataURL()
        link.click()
    }

    return (
        <Stack w={{ base: '100%', md: '200px' }} maxW="200px" gap={2} >
            {!hideTitle && <Heading size="md">{t('qr.title')}</Heading>}
            <Box ref={qrRef} bg={eventId ? "white" : "var(--mc-fill-soft)"} p={3} borderRadius="lg">
                {eventId ? (<QRCodeCanvas value={qrValue.toString()} size={180} />) : <Text color="fg.muted">{t('qr.placeholder')}</Text>}
            </Box>
            {eventId && (
                <>
                    <Flex gap={1}>
                        <Input
                            size="xs"
                            value={qrValue.toString()}
                            readOnly
                            fontSize="xs"
                            fontFamily="'JetBrains Mono', monospace"
                            color="fg.muted"
                        />
                        <IconButton
                            aria-label={t('qr.copyEventUrl')}
                            size="xs"
                            variant="ghost"
                            onClick={() => {
                                navigator.clipboard.writeText(qrValue.toString())
                                toaster.create({ title: t('common.urlCopied'), status: 'success' })
                            }}
                        >
                            <LuCopy />
                        </IconButton>
                    </Flex>
                    <Button w="full" variant="outline" onClick={downloadQR}>
                        <FiDownload /> {t('qr.downloadQr')}
                    </Button>
                </>
            )}
        </Stack>
    );
}
